  <div>メッセージ: <input name="popup" [(ngModel)]="text" style="width: 20em;"/></div>
  <button (click)="submit()">送信</button>
  <button (click)="cancel()">キャンセル</button>

